import type {
  ILxProfile,
  IAgentContract,
  IAgentContractClient,
  IAgentContractJob,
  IAgentContractSchedule,
} from '@/api/types';
import type { IUser } from '@/store/types';

export const profileConverter = (lxProfile: ILxProfile): IUser => ({
  ...lxProfile,
  displayLabels: lxProfile.agentContracts
    ? createDisplayLabels(
        lxProfile.agentContracts,
        lxProfile.agentContractClients,
        lxProfile.agentContractJobs,
        lxProfile.agentContractSchedules,
      )
    : [],
});

const createDisplayLabels = (
  agentContracts: IAgentContract[],
  agentContractClients: IAgentContractClient[] | null,
  agentContractJobs: IAgentContractJob[] | null,
  agentContractSchedules: IAgentContractSchedule[] | null,
) =>
  agentContracts.map(agentContract => {
    const agentClient = agentContractClients?.find(schedule => schedule.clientId === agentContract.clientId);
    const agentJob = agentContractJobs?.find(job => job.jobId === agentContract.jobId);
    const agentSchedule = agentContractSchedules?.find(schedule => schedule.clientId === agentContract.clientId);

    return {
      jobId: agentContract.jobId,
      jobLabel: agentJob?.jobName,
      contractId: agentContract.contractId,
      contractLabel: agentContract.contractName,
      scheduleId: agentSchedule?.scheduleId,
      scheduleLabel: agentSchedule?.scheduleName,
      scheduleShortLabel: agentSchedule?.scheduleNameShort,
      clientId: agentClient?.clientId,
      clientLabel: agentClient?.clientName,
      clientShortLabel: agentClient?.clientShortName,
    };
  });
